var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.48054 0.0194092C4.2481 0.0194092 9.59481e-07 4.2675 9.59481e-07 9.49995C9.59481e-07 14.7324 4.2481 18.9805 9.48054 18.9805C14.713 18.9805 18.9611 14.7324 18.9611 9.49995C18.9611 4.2675 14.713 0.0194092 9.48054 0.0194092ZM11.2211 9.49995C11.2211 8.53867 10.4419 7.75945 9.48061 7.75945C9.01899 7.75945 8.57618 7.9428 8.24977 8.26925C7.92336 8.59567 7.73997 9.03836 7.73997 9.50002V14.4845C7.73997 14.9462 7.92336 15.3889 8.24977 15.7153C8.57618 16.0417 9.01892 16.2251 9.48054 16.2251C10.4418 16.2251 11.2211 15.4459 11.2211 14.4846V9.49995ZM9.48054 2.75074C8.51989 2.75074 7.73997 3.53066 7.73997 4.49131C7.73997 5.45195 8.51989 6.23187 9.48054 6.23187C10.4412 6.23187 11.2211 5.45195 11.2211 4.49131C11.2211 3.53066 10.4412 2.75074 9.48054 2.75074Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.266bd52f611d577e928d866f977dfdda.svg";
export { ForwardRef as ReactComponent };